
import { IonContent, IonHeader, IonFooter, IonTitle, IonToolbar, IonButtons, } from '@ionic/vue';
import { defineComponent, ref } from 'vue';
import fUI from '../integration/foodexUI'

export default defineComponent({
    name: fUI.ID.RefundModal,
    components: { IonContent, IonHeader, IonFooter, IonTitle, IonToolbar, IonButtons, },
    props: {
        details: { type: Object, required: true },
    },
    setup(props: any) {
        const amount = ref(0)
        const source = ref('FOODEX')
        const msg = ref('')

        const onSucces = () => {
            fUI.modalSuccess(fUI.ID.RefundModal, {
                success: true,
                    amount: amount.value,
                    msg: msg.value,
                    source: source.value,
            })
        }

        const updateValue = (event: any) => {
            const value = event.target.value
            amount.value = 0
            if (value)
            {
                amount.value = +value >= props.details.grandTotal ? props.details.grandTotal : (+value).toFixed(2)
            }
        }
        
        return {
            amount,
            msg,
            source,
            onDismiss: () => fUI.modalCancel(fUI.ID.RefundModal),
            onSucces,
            updateValue,
        }
    },
})
